module.exports = __webpack_public_path__ + "prod/1.42.2/img/geely-icon.bfbdee0d.png";